import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <main
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: '24px',
        textAlign: 'center',
        backgroundColor: 'var(--theme-bg-primary)',
        color: 'var(--theme-text-primary)',
      }}
    >
      <div style={{ maxWidth: '800px', margin: '0 auto', width: '100%' }}>
        <h1 style={{ fontSize: '2rem', marginBottom: '8px' }}>Page Not Found</h1>
        <p style={{ color: 'var(--theme-text-secondary)', marginBottom: '24px' }}>
          The page you're looking for doesn't exist.
        </p>
        <Link
          to="/"
          style={{
            padding: '10px 24px',
            borderRadius: '8px',
            backgroundColor: 'var(--theme-accent)',
            color: 'var(--theme-text-on-accent)',
            textDecoration: 'none',
            fontWeight: 500,
          }}
        >
          Go Home
        </Link>
      </div>
    </main>
  );
};

export default NotFoundPage;
